import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import * as moment from 'moment';
import { ChartConfiguration, Chart } from "chart.js";
import { ChartData, ChartDataFormat } from "../shared/interfaces/ChartData";
import { LoaderService } from "src/app/utils/loader.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  statsData: any;
  name;
  chartsData: ChartData;
  selectedValue: string = "currentYear";
  startDate: string;
  endDate: string;

  private chartTitle: string = "Gross Volume";
  private chartElement: any;
  private chartElement2: any;
  private chartElement3: any;
  private chartObject: any;
  private chartObject2: any;
  private chartObject3: any;
  public lineChartPlugins = [];
  enquiryChartData: ChartDataFormat[] = [];
  orderChartData: ChartDataFormat[] = [];
  revenueChartData: ChartDataFormat[] = [];

  constructor(
    private adminService: AdminService,
    private router: Router,
    private loaderService: LoaderService) {

    this.name = localStorage.getItem("name");
    let status = localStorage.getItem("has_onboarded");
    if (status == "false") {
      this.router.navigate(["/onboarding"]);
    } else {
      return;
    }
  }

  ngOnInit() {
    this.adminService.getUserStatistics().subscribe(
      (res: any) => {
        this.statsData = res.body;
      },
      (err) => {
        console.log(err);
      }
    );

    this.updateDates(this.selectedValue);
    this.getChartsDetails();
  }

  getChartsDetails() {
    this.loaderService.display(true);
    this.adminService
      .getDashboardCharts(this.startDate, this.endDate, this.getFrequency(this.selectedValue))
      .subscribe(
        (res: any) => {
          this.loaderService.display(false);
          this.chartsData = res.body;
          this.enquiryChartData = this.chartsData.enquiries;
          this.orderChartData = this.chartsData.orders;
          this.revenueChartData = this.chartsData.revenue;
          console.log(this.chartsData);
          this.updateCharts();
        },
        (err) => {
          console.log(err);
          this.loaderService.display(false);
        }
      );
  }

  private getFrequency(selection: string) {
    switch (selection) {
      case 'currentYear':
        return 'month';
      case 'currentMonth':
        return 'week';
      case 'currentWeek':
        return 'date';
      case 'last5Years':
        return 'year';
      default:
        break;
    }
  }

  initializeChart() {
    this.chartElement = document.getElementById("dashboardEnquiriesChart");
    this.chartElement2 = document.getElementById("dashboardOrdersChart");
    this.chartElement3 = document.getElementById("dashboardRevenueChart");

    this.chartObject = new Chart(this.chartElement, {
      type: "line",
      data: this.enquiryChartConfig(),
      options: this.getChartOptions("Enquiries Data"),
      plugins: this.lineChartPlugins,
    });
    this.chartObject2 = new Chart(this.chartElement2, {
      type: "line",
      data: this.ordersChartConfig(),
      options: this.getChartOptions("Orders Data"),
      plugins: this.lineChartPlugins,
    });
    this.chartObject3 = new Chart(this.chartElement3, {
      type: "line",
      data: this.revenueChartConfig(),
      options: this.getChartOptions("Revenue Data"),
      plugins: this.lineChartPlugins,
    });
  }

  updateCharts() {
    if (this.chartObject) {
      this.chartObject.destroy();
    }
    if (this.chartObject2) {
      this.chartObject2.destroy();
    }
    if (this.chartObject3) {
      this.chartObject3.destroy();
    }

    this.chartElement = document.getElementById("dashboardEnquiriesChart");
    this.chartElement2 = document.getElementById("dashboardOrdersChart");
    this.chartElement3 = document.getElementById("dashboardRevenueChart");

    this.chartObject = new Chart(this.chartElement, {
      type: "line",
      data: this.enquiryChartConfig(),
      options: this.getChartOptions("Enquiries Data"),
      plugins: this.lineChartPlugins,
    });
    this.chartObject2 = new Chart(this.chartElement2, {
      type: "line",
      data: this.ordersChartConfig(),
      options: this.getChartOptions("Orders Data"),
      plugins: this.lineChartPlugins,
    });
    this.chartObject3 = new Chart(this.chartElement3, {
      type: "line",
      data: this.revenueChartConfig(),
      options: this.getChartOptions("Revenue Data"),
      plugins: this.lineChartPlugins,
    });
  }

  updateDates(value: string) {
    const today = new Date();
    let startDate: Date;

    switch (value) {
      case "currentYear":
        startDate = new Date(today.getFullYear(), 0, 1);
        break;
      case "currentMonth":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        break;
      case "currentWeek":
        const firstDayOfWeek = today.getDate() - today.getDay();
        startDate = new Date(today.setDate(firstDayOfWeek));
        break;
      case "last5Years":
        startDate = new Date(
          today.getFullYear() - 5,
          today.getMonth(),
          today.getDate()
        );
        break;
      default:
        startDate = today;
    }

    this.startDate = this.formatDate(startDate);
    this.endDate = this.formatDate(new Date());
  }

  // updateDates(value: string) {
  //   const today = new Date();
  //   let startDate: Date;
  //   let endDate: Date;

  //   switch (value) {
  //     case "currentYear":
  //       startDate = new Date(today.getFullYear(), 0, 1); // Jan 1 of current year
  //       endDate = new Date(today.getFullYear(), 11, 31); // Dec 31 of current year
  //       break;

  //     case "currentMonth":
  //       startDate = new Date(today.getFullYear(), today.getMonth(), 1); // 1st of current month
  //       endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of current month
  //       break;

  //     case "currentWeek":
  //       const todayNew = new Date();
  //       const firstDayOfWeek = today.getDate() - today.getDay(); // Adjust to Sunday of current week
  //       startDate = new Date(today.getFullYear(), today.getMonth(), firstDayOfWeek); // Start of the week
  //       endDate = new Date(todayNew.getFullYear(), todayNew.getMonth(), firstDayOfWeek + 6); // End of the week

  //       // Check for year rollover
  //       if (endDate.getFullYear() > today.getFullYear()) {
  //         endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
  //       }
  //       break;

  //     case "last5Years":
  //       startDate = new Date(today.getFullYear() - 5, 0, 1); // Jan 1, 5 years ago
  //       endDate = new Date(today.getFullYear() - 1, 11, 31); // Dec 31 of last year
  //       break;

  //     default:
  //       startDate = today;
  //       endDate = today;
  //   }

  //   // this.startDate = startDate.toISOString().split("T")[0];
  //   // this.endDate = endDate.toISOString().split("T")[0];
  //   this.startDate = this.formatDate(startDate);
  //   this.endDate = this.formatDate(endDate);
  // }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  onSelectionChange(event: any) {
    console.log("Selected value:", event.value);
    this.selectedValue = event.value;
    if (event.value !== 'custom') {
      this.updateDates(this.selectedValue);
      this.getChartsDetails();
    }

  }

  onDateChange(): void {
    // Triggered when start or end date changes
    console.log('Start Date:', this.startDate);
    console.log('End Date:', this.endDate);
  }

  onGoClick(): void {
    // Validate and process the custom date range
    if (this.startDate && this.endDate) {
      console.log('Custom Date Range:', {
        start: this.startDate,
        end: this.endDate
      });
      this.getChartsDetails();
    }
  }

  private constructXvalue(x: any) {
    switch (this.chartsData.group_by) {
      case 'week':
        return `Week ${x}`
      case 'month':
        return this.getShortMonthName(x)
      case 'time':
        return `${x}`
      case 'date':
        return moment(x).format('MMM DD');
      case 'year':
        return x.toString();
      default:
        return x;
    }
  }

  getShortMonthName(monthNumber: number): string {
    const shortMonthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    if (monthNumber < 1 || monthNumber > 12) {
      throw new Error("Invalid month number. It should be between 0 and 11.");
    }

    return shortMonthNames[monthNumber-1];
  }

  public generateChartConfig(chartData: any[], label: string): ChartConfiguration["data"] {
    const labels = chartData?.map((item) => {
      switch (this.selectedValue) {
        case 'currentYear':
          // return moment(`${item.year}-${item.month}`, 'YYYY-MM').format('MMM YYYY');
          // return moment(item.x).format('MMM DD, YYYY');
          return this.constructXvalue(item.x);
        case 'currentMonth':
          return this.constructXvalue(item.x);
        case 'currentWeek':
          return this.constructXvalue(item.x);
        case 'last5Years':
          return this.constructXvalue(item.x);
        case 'custom':
          return this.constructXvalue(item.x);
        default:
          return '';
      }
    });

    return {
      labels: labels,
      datasets: [
        {
          data: chartData?.map((item) => item.y),
          label: label,
          fill: false,
          borderColor: "rgb(255, 105, 0)",
          backgroundColor: "rgba(255,0,0,0.3)", // Only for filled
          spanGaps: true,
          lineTension: 0,
        },
      ],
    };
  }

  public enquiryChartConfig(): ChartConfiguration["data"] {
    return this.generateChartConfig(this.enquiryChartData, "Enquiries");
  }

  public ordersChartConfig(): ChartConfiguration["data"] {
    return this.generateChartConfig(this.orderChartData, "Orders");
  }

  public revenueChartConfig(): ChartConfiguration["data"] {
    return this.generateChartConfig(this.revenueChartData, "Revenue");
  }

  // public enquiryChartConfig(): ChartConfiguration["data"] {
  //   return {
  //     // labels: this.enquiryChartData?.map((item) => item.x),
  //     labels: this.enquiryChartData?.map((item) => moment(`${item.year}-${item.month}`, 'YYYY-MM').format('MMM YYYY')),
  //     datasets: [
  //       {
  //         data: this.enquiryChartData?.map((item) => item.y),
  //         label: "Enquiries",
  //         fill: false,
  //         borderColor: "rgb(255, 105, 0)",
  //         backgroundColor: "rgba(255,0,0,0.3)", //Only for filled
  //         spanGaps: true,
  //         lineTension: 0,
  //       },
  //     ],
  //   };
  // }

  // ordersChartConfig(): ChartConfiguration["data"] {
  //   return {
  //     // labels: this.orderChartData?.map((item) => item.x),
  //     labels: this.orderChartData?.map((item) => moment(`${item.year}-${item.month}`, 'YYYY-MM').format('MMM YYYY')),
  //     datasets: [
  //       {
  //         data: this.orderChartData?.map((item) => item.y),
  //         label: "Orders",
  //         fill: false,
  //         borderColor: "rgb(255, 105, 0)",
  //         backgroundColor: "rgba(255,0,0,0.3)", //Only for filled
  //         spanGaps: true,
  //         lineTension: 0,
  //       },
  //     ],
  //   };
  // }

  // public revenueChartConfig(): ChartConfiguration["data"] {
  //   return {
  //     // labels: this.revenueChartData?.map((item) => item.x),
  //     labels: this.revenueChartData?.map((item) => moment(`${item.year}-${item.month}`, 'YYYY-MM').format('MMM YYYY')),
  //     datasets: [
  //       {
  //         data: this.revenueChartData?.map((item) => item.y),
  //         label: "Revenue",
  //         fill: false,
  //         borderColor: "rgb(255, 105, 0)",
  //         backgroundColor: "rgba(255,0,0,0.3)", //Only for filled
  //         spanGaps: true,
  //         lineTension: 0,
  //       },
  //     ],
  //   };
  // }

  getChartOptions(chartTitle: string = ""): ChartConfiguration["options"] {
    const ChartOptions: ChartConfiguration["options"] = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          fontColor: "rgb(0, 0, 0)",
        },
      },
      title: {
        display: true,
        text: chartTitle,
        fontSize: 20,
        fontStyle: "bold",
      },
      layout: {
        padding: {
          left: 0,
          right: 30,
          top: 0,
          bottom: 0,
        },
      },
      //:DOESN'T WORK WITH V2. Only with V4
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false, // remove x-axis grid lines
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
      plugins: {
        legend: {
          position: "top",
          labels: {
            color: "white",
          },
        },
        title: {
          display: true,
          text: this.chartTitle,
          color: "white",
        },
      },
      elements: {
        point: {
          radius: 7,
          hitRadius: 2,
        },
      },
    };
    return ChartOptions;
  }
}
